import { useState, useCallback } from 'react';

/**
 * A simple toggle hook that can be used to replace jQuery toggle
 * @param {boolean} initialState - Initial state of the toggle
 * @returns {Array} - [state, toggle, setState]
 */
const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);

  // Define toggle function
  const toggle = useCallback(() => {
    setState(prevState => !prevState);
  }, []);

  return [state, toggle, setState];
};

export default useToggle;
